<template>
  <main id="testimonials" role="main">

    <dlnkwait :wait_data="wait_data"></dlnkwait>

    <dlnkalert
        :message="message"
        :message_type="message_type"
        @close="closeMessage()"
    ></dlnkalert>

    <div class="container bg-white space-1 ">

      <div class="d-flex space-1">
        <div class="col-lg-9 p-0">
          <h2><!--renvoyer le nombre de commentaire--> Partages d'expérience</h2></div>
        <div class="col-auto">
          <a href="#poster" class="btn btn-primary">Partager mon expérience</a>
        </div>
      </div>


      <!-- Search -->

      <div class="row justify-content-md-between align-items-md-center pb-4">
        <div class="col-md-5 mb-3 mb-md-0">
          <h2 class="h5 mb-0">{{ testimonials_count }} partages d'expériences</h2>
        </div>

        <div class="col-md-7 col-lg-6 text-md-right">
          <!-- Input -->
          <form class="input-group input-group-merge">
            <input type="search" class="form-control" placeholder="Recherche ciblée" aria-label="Recherche ciblée"
                   aria-describedby="search-appreciation">
            <div class="input-group-append">
                    <span class="input-group-text" id="searchApp">
                      <i class="fas fa-search"></i>
                    </span>
            </div>
          </form>
          <!-- End Input -->
        </div>
      </div>

      <!-- End Search -->

      <div class="d-flex justify-content-center">
        <dlnkpagination
            :page="page"
            :page_count="page_count"
            @next_page="next_page()"
            @prev_page="prev_page()"
            @set_page="set_page($event)">
        </dlnkpagination>
      </div>


      <ul class="list-unstyled">

        <!-- Comment -->
        <li class="mb-5" v-for="testimonial in testimonials" :key="testimonial.id">

          <div class="media align-items-center mb-2">
            <span class="avatar avatar-sm avatar-primary avatar-circle mr-3">
              <span class="avatar-initials">{{ testimonial.author.initials }}</span>
            </span>

            <div class="media-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <span class="h5 mb-0">{{ testimonial.author.name }}</span>
                  <span class="badge badge-pill badge-primary ml-4">{{ testimonial.topic }}</span>
                </div>
                <div>
                  <small class="text-muted">le {{ testimonial.created_at }}</small>
                </div>
              </div>
            </div>

            <!--dépendant de qui est connecter sur la page-->
            <a v-if="admin > 0 || customer_id == testimonial.author.id"  class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
               aria-haspopup="true"
               aria-expanded="false">
              <i class="fa fa-cog" aria-hidden="true"></i>
            </a>

            <div v-if="admin > 0 || customer_id == testimonial.author.id"  class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
              <a class="dropdown-item" href="javascript:void(0)" @click="delete_testimonial(testimonial.id)">Supprimer le message</a>
            </div>

          </div>

          <p>
            {{ testimonial.comment }}
          </p>

          <div class="media-footer">

            <button v-if="testimonial.author.like == 0" type="button" class="btn btn-ghost-primary btn-xs" @click="like(testimonial.id)">
              <span>
                <i class="fa fa-thumbs-up" aria-hidden="true"></i> J'aime
              </span>
            </button>
            <button v-else type="button" class="btn btn-ghost-danger btn-xs" @click="dislike(testimonial)">
              <span>
                <i class="fa fa-thumbs-down" aria-hidden="true"></i> Je n'aime plus
              </span>
            </button>


            <!--            <button type="button" class="btn btn-ghost-danger btn-xs" @click="dislike(testimonial.id)">-->
<!--              <span>-->
<!--                <i class="fa fa-thumbs-down" aria-hidden="true"></i> Je n''aime pas-->
<!--              </span>-->
<!--            </button>-->
          </div>
        </li>
        <!-- End Comment -->
      </ul>

      <div class="d-flex justify-content-center">
        <dlnkpagination
            :page="page"
            :page_count="page_count"
            @next_page="next_page()"
            @prev_page="prev_page()"
            @set_page="set_page($event)">
        </dlnkpagination>
      </div>

      <div class="mb-5 border-top" id="poster">
        <h3 class="mt-5">Partager votre expérience</h3>
      </div>


      <form method="post" id="comment_form" class="needs-validation" novalidate @submit.prevent="post_comment">

        <div class="form-row">
<!--          <div class="col-sm-6 mb-sm-3">-->
<!--            <div class="js-form-message form-group">-->
<!--              <label for="testimonial_name" class="input-label">Votre nom</label>-->
<!--              <input type="text" class="form-control" name="testimonial[name]"-->
<!--                     id="testimonial_name" placeholder="Votre nom" aria-label="Votre nom" required=true>-->
<!--            </div>-->
<!--          </div>-->

          <div class="col-sm-6 mb-sm-3">
            <div class="js-form-message form-group">
              <label for="testimonial_topic" class="input-label">Nom de la sortie</label>
              <input type="text" id="testimonial_topic" class="form-control" name="testimonial[topic]"
                     placeholder="Sujet" aria-label="Sujet" required=true>
            </div>
          </div>

          <div class="col-12 mb-sm-3">
            <div class="js-form-message form-group">
              <label for="testimonial_comment" class="input-label">Commentaire</label>
              <textarea class="form-control" rows="7" id="testimonial_comment" placeholder="Votre commentaire"
                        required=true
                        name="testimonial[comment]"></textarea>
            </div>
          </div>
        </div>

        <div class="d-flex ">
          <button type="submit" class="btn btn-primary btn-wide transition-3d-hover">Poster mon experience</button>
        </div>
      </form>
    </div>


  </main>
</template>

<script>

export default {
  props: {
    admin: Number,
    customer_id: Number,
  },

  data: function () {
    return {
      message: "",
      message_type: "",
      wait_data: Boolean,

      testimonials: [],
      page: 1,
      page_count: 0,
      testimonials_count: 0
    }
  },

  mounted() {
    this.wait_data = true
    this.get_data()
  },

  watch: {

    page: function (new_val, old_val) {

      if (new_val < 1) {
        this.page = 1
      }

      if (new_val > this.page_count) {
        this.page = this.page_count
      }

      this.get_data()
    },

  },

  methods: {

    closeMessage: function () {
      this.message = "";
      this.message_type = "";
    },

    set_page: function (page) {
      page = parseInt(page)
      this.page = page
    },

    next_page: function () {
      this.page++
    },

    prev_page: function () {
      this.page--
    },

    get_data: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "testimonials.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id
      api_url += '&page=' + _this.page

      axios.get(api_url)
          .then(function (response) {
            _this.testimonials = response.data.testimonials
            _this.page = response.data.meta.page
            _this.page_count = response.data.meta.pages
            _this.testimonials_count = response.data.meta.count
            _this.wait_data = false
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },

    clean_field: function () {
      this.picture = ""
      document.getElementById("comment_form").reset();
      document.getElementById("comment_form").classList.remove("was-validated");
    },

    delete_testimonial: async function (id) {
      let _this = this
      let [secure_key, customer_id, api_url] = await get_token_2()

      api_url += "/testimonials/" + id + ".json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios({
        method: 'delete',
        url: api_url
      })
          .then(function (response) {
            _this.message = "Commentaire supprimé"
            _this.message_type = "alert-success"
            _this.get_data()
          })
          .catch(function (error) {
            _this.message = "Erreur inconnu"
            _this.message_type = "alert-danger";
          });


    },

    post_comment: async function () {
      let _this = this
      let [secure_key, customer_id, api_url] = await get_token_2()

      api_url += "testimonials.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      // const form_data = new FormData();
      const form_element = document.getElementById("comment_form");
      const form_data = new FormData(form_element);

      axios({
        method: 'post',
        url: api_url,
        data: form_data
      })
          .then(function (response) {
            _this.message = "Votre commentaire est enregistré";
            _this.message_type = "alert-success";
            _this.get_data()
            _this.clean_field()
          })
          .catch(function (error) {
            _this.message = "Erreur inconnu"
            _this.message_type = "alert-danger";
          });
    },

    like: async function (id) {
      let _this = this
      let [secure_key, customer_id, api_url] = await get_token_2()

      api_url += "/testimonials/" + id + "/testimonial_likes.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios({
        method: 'post',
        url: api_url
      })
          .then(function (response) {
            _this.message = "Votre J'aime est enregistré"
            _this.message_type = "alert-success"
            _this.get_data()
          })
          .catch(function (error) {
            _this.message = "Erreur inconnu"
            _this.message_type = "alert-danger";
          });

    },

    dislike: async function (testimonial) {
      let _this = this
      let [secure_key, customer_id, api_url] = await get_token_2()

      api_url += "/testimonials/" + testimonial.id + "/testimonial_likes/" + testimonial.author.like + ".json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios({
        method: 'delete',
        url: api_url
      })
          .then(function (response) {
            _this.message = "Vous n'aimez plus ce commetaire"
            _this.message_type = "alert-success"
            _this.get_data()
          })
          .catch(function (error) {
            _this.message = "Erreur inconnu"
            _this.message_type = "alert-danger";
          });

    },
  },

}

</script>